enum WorkspaceProjectDatasetStatus {
  pending = 'pending',
  archived = 'archived',
  deployed = 'deployed',
}

export default WorkspaceProjectDatasetStatus
